define('shims',[],function() {

  window.requestAnimationFrame = window.requestAnimationFrame || function(f) { setTimeout(f, 16) };

});
